import { useDeliveryOptions } from '../../hooks/useDeliveryOptions';
import { useFormContext } from 'react-hook-form';
import { Flex } from '@repo/ui/Flex';
import { LocationPreviewCard } from './LocationPreviewCard';

import s from './LocationPreview.module.css';
import { formatLocationAddressSingle } from '../../utils/address';
import type { Placeholder } from '../../graphql/query/getDelivery';
import { PlaceholderCard } from './PlaceholderCard';

export const LocationPreview = ({
  placeholder,
}: {
  placeholder: Placeholder;
}) => {
  const { watch } = useFormContext();
  const { deliveryOptions } = useDeliveryOptions();
  const [selectedMethod, selectedLocationId] = watch([
    'returnMethod.type',
    'returnMethod.location',
  ]);
  const method = deliveryOptions?.find((e) => e.id === selectedMethod);
  const locations = method?.locations;
  const selectedLocation = locations?.find((e) => e.id === selectedLocationId);

  const noLocation = !selectedLocation || locations?.length === 0;

  if (noLocation) {
    return placeholder ? (
      <PlaceholderCard method={method} placeholder={placeholder} />
    ) : null;
  }

  const { storeName, address, logoUrl, distance } = selectedLocation;

  return (
    <Flex className={s.locationWrapper} padding="p-16" gap="g-12">
      <LocationPreviewCard
        title={storeName}
        description={formatLocationAddressSingle(address)}
        icon={logoUrl}
        attribute={`${distance ?? ''}`}
      />
    </Flex>
  );
};
